import { staleTimes, useQuery } from '@platform/api-client';
import type { Operation, ResponseBody, TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';

export type DashboardStats = ResponseBody<Operation<'/admin/dashboard/stats', 'get'>>;
export type ParcelsAtCarriers = DashboardStats['parcelsAtCarriers'];

export const PARCEL_STATUSES = [
  { field: 'atDepot', status: 'DISPATCHED' },
  { field: 'inTransit', status: 'IN_TRANSIT' },
  { field: 'outForDelivery', status: 'OUT_FOR_DELIVERY' },
  { field: 'deliveryFailed', status: 'DELIVERY_FAILED' },
  { field: 'returning', status: 'RETURNING' },
] as const satisfies readonly { field: keyof ParcelsAtCarriers; status: string }[];

export const parcelsTotalOf = (parcels: ParcelsAtCarriers): number =>
  PARCEL_STATUSES.reduce((total, { field }) => total + parcels[field], 0);

export const useDashboardStats = (api: TypedClient, company: string | null) => {
  const { tenantId } = usePageContext();
  return useQuery({
    queryKey: [...queryKeys.dashboard(tenantId), 'stats', company],
    queryFn: () => api.get('/admin/dashboard/stats', { query: company === null ? {} : { company } }),
    staleTime: staleTimes.dashboard,
  });
};
